import { z } from 'zod';
// ---------------------------------------------------------------------------
// Instancia — un número de WhatsApp de Metamorfosis en Evolution (Ciclo 1b, R1).
// Son datos, no configuración de entorno: la UI toma etiqueta y color de acá.
// ---------------------------------------------------------------------------
export const instanciaPublicSchema = z.object({
    // La clave con la que Evolution nombra la instancia ("Metamorfosis 2").
    nombre: z.string(),
    // El número en dígitos (549…), para mostrar y para reconocer el propio chat.
    numero: z.string(),
    // Corta, para chips y cabeceras ("M2").
    etiqueta: z.string(),
    // Color de marca del número, en HSL sin envoltorio ("81 41% 29%"), como los tokens.
    color: z.string(),
    activa: z.boolean(),
    orden: z.number().int(),
});
//# sourceMappingURL=instancia.js.map